import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = ["value"]

import { defineEmits, defineProps } from "vue/dist/vue";
import SelectOption from "@/Interfaces/SelectOption";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputSelectOption',
  props: {
    modelValue: {},
    options: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const updateValue = ($event: Event) => {
  emit("update:modelValue", ($event.target as HTMLSelectElement).value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("select", {
    value: props.modelValue,
    class: "w-full text-white placeholder-gray-400 focus:backdrop-blur-sm focus:border-purple-700 bg-opacity-10 bg-transparent border border-white rounded-lg px-4 py-2 text-[#e2e1e5] transition duration-200 shadow-md",
    onInput: _cache[0] || (_cache[0] = ($event: any) => (updateValue($event)))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
      return (_openBlock(), _createElementBlock("option", {
        value: option.value,
        key: option.value,
        class: "bg-custom-black"
      }, _toDisplayString(option.label), 9, _hoisted_2))
    }), 128))
  ], 40, _hoisted_1))
}
}

})